import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { StatefulComponent } from '../stateful/stateful.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { selectShowLoadingMask } from '../../ngrx/app.state';

@Component({
    selector: 'app-loading-mask',
    templateUrl: './loading-mask.component.html',
    styleUrls: ['./loading-mask.component.scss'],
    standalone: true,
    imports: [NgIf, MatProgressSpinnerModule]
})
export class LoadingMaskComponent extends StatefulComponent implements OnInit {
  showLoader = true;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.subs.push(this.select(selectShowLoadingMask).subscribe((showLoader) => {
      this.showLoader = showLoader;
      this.cd.detectChanges();
    }));
  }
}
